var _linearGradient, _path, _linearGradient2, _polygon, _circle, _circle2, _circle3, _circle4, _linearGradient3, _path2, _linearGradient4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8PasswordReset50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7BDWD4ZdDeZm~8SgpcfAFa",
    x1: 16.904,
    x2: 33.664,
    y1: 47.845,
    y2: 16.325,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0077d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b59a2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7BDWD4ZdDeZm~8SgpcfAFa)",
    d: "M44.211,22H3.789C2.801,22,2,21.199,2,20.211V6.789C2,5.801,2.801,5,3.789,5h40.422 C45.199,5,46,5.801,46,6.789v13.422C46,21.199,45.199,22,44.211,22z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7BDWD4ZdDeZm~8SgpcfAFb",
    x1: 19.346,
    x2: 29.122,
    y1: 43.253,
    y2: 24.866,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#7BDWD4ZdDeZm~8SgpcfAFb)",
    points: "4,20 4,7 44,7 44,20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 13.5,
    r: 2.5,
    fill: "#0b5aa4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 13.5,
    r: 2.5,
    fill: "#0b5aa4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 13.5,
    r: 2.5,
    fill: "#0b5aa4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 13.5,
    r: 2.5,
    fill: "#0b5aa4"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7BDWD4ZdDeZm~8SgpcfAFc",
    x1: 19.786,
    x2: 27.731,
    y1: 4.075,
    y2: 19.016,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7BDWD4ZdDeZm~8SgpcfAFc)",
    d: "M23.741,44.996c-4.692-0.132-8.603-4.043-8.737-8.735C14.859,31.18,18.95,27,24,27v4 c-3.109,0-5.564,2.852-4.887,6.077c0.397,1.887,1.922,3.413,3.809,3.809c3.06,0.643,5.784-1.534,6.055-4.414 C29.003,36.209,29.207,36,29.472,36h3.007c0.284,0,0.522,0.239,0.506,0.522C32.709,41.327,28.645,45.135,23.741,44.996z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7BDWD4ZdDeZm~8SgpcfAFd",
    x1: 22.302,
    x2: 27.79,
    y1: 24.041,
    y2: 13.718,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7BDWD4ZdDeZm~8SgpcfAFd)",
    d: "M29.654,30.222l-5.239,4.567c-0.518,0.451-1.413,0.131-1.413-0.508l-0.009-9.561 c0-0.64,0.886-0.959,1.413-0.508l5.248,4.559C30.115,29.172,30.115,29.82,29.654,30.222z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PasswordReset50);
export default __webpack_public_path__ + "static/media/icons8-password-reset-50.e92536a9bc61a1322720266f226e5cab.svg";
export { ForwardRef as ReactComponent };